import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Portal code for this site. Both the SGDP storefront and the /adha sub-brand sell
 * through the same CDI purchase flow, so they share one code. Must match a Code in
 * dbo.PlanPurchasePortals exactly (case-sensitive) or the API rejects it as invalid.
 */
export const PORTAL_CODE = 'PurchasePortal';

/**
 * Stamps X-Portal-Code on every API call so the Sales API can apply the
 * organization's portal purchase restrictions. The API's enforcement is fail-open:
 * with no header it skips the restriction check entirely and the plan stays buyable.
 */
@Injectable()
export class PortalCodeInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    request = request.clone({
      setHeaders: {
        'X-Portal-Code': PORTAL_CODE
      }
    })
    return next.handle(request);
  }
}
